
// SVG Icon: folder
export default { id: "terriajs-folder" };
export const id = "terriajs-folder";
export const name = "folder";
